import { useCallback } from 'react';
import { Content } from '../services/UploadManagementServiceTypes';
import { useUploadContext } from './UploadManagementContext';

export const useDragAndDropEvents = (content: Content) => {
  const { deselectGuid, selectGuid, moveSelectedToGuid } = useUploadContext();

  const onDragStart: React.DragEventHandler = useCallback(
    (e) => {
      e.dataTransfer.dropEffect = 'move';
      selectGuid(content.guid);
    },
    [content.guid, selectGuid],
  );

  const onDrop: React.DragEventHandler = useCallback(
    (e) => {
      e.preventDefault();
      moveSelectedToGuid(content.guid);
    },
    [content.guid, moveSelectedToGuid],
  );

  const onDragOver: React.DragEventHandler = useCallback((e) => e.preventDefault(), []);
  const onDragEnd: React.DragEventHandler = useCallback(
    () => deselectGuid(content.guid),
    [content.guid, deselectGuid],
  );

  return { draggable: true, onDragStart, onDrop, onDragOver, onDragEnd };
};
